import Model from './Model'

export default class ProhibitedWords extends Model {
    // Set the resource route of the model
    resource() {
        return 'prohibited-words'
    }
}
